// extracted by mini-css-extract-plugin
module.exports = {"achievementsItem":"styles_achievementsItem__W33C4","complete":"styles_complete__1-VZR","proPath":"styles_proPath__1mWOE"};